import { env } from './env';

/**
 * 統一的日誌記錄服務
 * 根據環境(開發/生產)控制日誌輸出
 * 支援多種日誌級別
 */
export class LogService {
  private static readonly isProduction = env.isProduction;

  /**
   * 信息日誌
   */
  public static info(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.info(`[INFO] ${message}`, ...args);
    }
    // TODO: 在此處添加生產環境的日誌收集邏輯，例如發送到遠程日誌服務
  }

  /**
   * 警告日誌
   */
  public static warn(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.warn(`[WARN] ${message}`, ...args);
    }
    // TODO: 在此處添加生產環境的警告日誌收集邏輯
  }

  /**
   * 錯誤日誌
   */
  public static error(message: string, error?: unknown, ...args: unknown[]): void {
    console.error(`[ERROR] ${message}`, error, ...args);
    // TODO: 任何環境下都必須記錄錯誤日誌，並可選地發送到遠程服務
  }

  /**
   * 調試日誌
   */
  public static debug(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  }

  /**
   * 追蹤日誌
   */
  public static trace(message: string, ...args: unknown[]): void {
    if (!this.isProduction) {
      console.trace(`[TRACE] ${message}`, ...args);
    }
  }

  /**
   * 記錄 API 請求日誌
   */
  public static logApiRequest(endpoint: string, method: string, params?: unknown): void {
    this.info('API Request', { endpoint, method, params });
  }

  /**
   * 記錄 API 響應日誌
   */
  public static logApiResponse(endpoint: string, status: number, response?: unknown): void {
    if (status >= 200 && status < 300) {
      this.info('API Response Success', { endpoint, status, response });
    } else {
      this.warn('API Response Warning', { endpoint, status, response });
    }
  }

  /**
   * 記錄 API 錯誤日誌
   */
  public static logApiError(endpoint: string, error: unknown): void {
    this.error('API Request Failed', error, { endpoint });
  }

  /**
   * 記錄用戶操作日誌
   */
  public static logUserAction(action: string, details?: unknown): void {
    this.info('User Action', { action, details, timestamp: new Date().toISOString() });
  }

  /**
   * 記錄性能日誌
   */
  public static logPerformance(operation: string, duration: number, details?: unknown): void {
    this.info('Performance', { operation, duration, details });
  }
}

// 導出單例實例
export const logService = LogService;
